import { Col, Row, Text } from 'components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { FadeInSlider } from '../../components';

const Wrapper = styled.div`
  margin-top: 13px;

  @media (max-width: 1024px) {
    margin-top: 86px;
  }
`;

const HeaderTitle = styled.div`
  position: relative;
  font-family: CeraStencil;
  font-size: 64px;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: -2.5px;
  height: 160px;
  top: 15px;

  div {
    position: absolute;
    width: 512px;
  }
`;

const Shoutout = (props) => {
  const { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation();

  return (
    <Col marg={isMobile ? '85px 0 0' : '98px 0 0'} noFlex className="bepis" center centerAll>
      <FadeInSlider
        headerTitle={
          <Row wid="420px">
            <Text
              stencil
              size="72px"
              bold
              lineHt="54px"
              style={{
                letterSpacing: -3.5,
                textIndent: 50
              }}
            >
              {t('website.experienceSport')}
            </Text>
          </Row>
        }
        headerText={[
          t('website.theOnlySportsApp'),
          t('website.buildYourOwnWorld'),
          t('website.chooseTheFeatures'),
          t('website.interactWithAthletes')
        ]}
        sliderElements={[
          {
            image: require('assets/images/cheering-phone-tilted.png'),
            title: t('website.shoutout!'),
            content: t('website.sendAShoutout')
          },
          {
            image: require('assets/images/tennis-phone-tilted.png'),
            title: t('website.connect!'),
            content: t('website.unlimitedAccess')
          },
          {
            image: require('assets/images/cheering-phone-tilted.png'),
            title: t('website.stream!'),
            content: t('website.streamGamesFrom')
          }
        ]}
      />
    </Col>
  );
};

export default Shoutout;
